import { createContext } from 'react';

export const DefaultLanguageContext = createContext();
export const MakeFocusableContext = createContext();
export const RefetchStacksContext = createContext();
export const PreloadContext = createContext();
export const IsOttContext = createContext();